import React, { Component } from 'react';

class Login extends Component {
    render() {
        return (
            <div>
                 this is login
            </div>
        );
    }
}

export default Login;